import React, { useState } from 'react';
import styles from './FAQ.module.scss';
import { RiAddLine } from 'react-icons/ri';
import { faqData } from './constants';

const FAQ = () => {
    const [openItemId, setOpenItemId] = useState(null);

    const toggleItem = (id) => {
        setOpenItemId(openItemId === id ? null : id);
    };

    return (
        <section className={styles.faqSection} id="faq">
            <h2 className={styles.faqTitle}>Часті запитання</h2>
            <div className={styles.faqContainer}>
                {faqData.map((item) => (
                    <div key={item.id} className={`${styles.faqItem} ${openItemId === item.id ? styles.active : ''}`}>
                        <button className={styles.faqQuestion} onClick={() => toggleItem(item.id)}>
                            {item.question}
                            <span className={styles.icon}>
                                <RiAddLine />
                            </span>
                        </button>
                        <div className={styles.faqAnswer} style={{ maxHeight: openItemId === item.id ? '500px' : '0' }}>
                            <p>{item.answer}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default FAQ;